import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

const styles: Record<string, SxProps> = {
  mainContainer: {
    width: '100%',
    marginBottom: spacing(1),

    // Rob - MuiTabs has a default height of 48px,
    // removing it here so that the height is determined by the content
    // and we don't have to change the height of MuiTabs-scrollButtons
    '.MuiTabs-root': {
      minHeight: 'unset'
    },
    // styles for scroll-arrows
    '.MuiTabs-scrollButtons': {
      svg: {
        fontSize: '1.75rem'
      }
    },
    '.MuiTabs-scrollButtons.Mui-disabled': {
      width: '0'
    },

    // styles for chip
    '.MuiChip-root': {
      borderRadius: '0.25rem',
      background: palette.grey['50']
    },

    // styles for cross icon
    '.MuiButtonBase-root .MuiChip-deleteIcon': {
      color: palette.grey.main,
      fontSize: '1rem'
    }
  },

  chipList: {
    marginRight: spacing(0.3)
  },

  list: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  }
};

export default styles;
